/* eslint-disable import/prefer-default-export */

export const getCities = state => state.cities
export const getStates = state => state.states
export const getColonies = state => state.colonies

// * 08/11/2022 - TAG: Get the original route after calling customer form
export const getOriginRouteToCustomerForm = state => state.originRouteToCustomerForm
